import {
	Flex,
	Tooltip,
	Text,
	Button,
	useToast,
	Box,
	AlertDialog,
	AlertDialogBody,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogContent,
	AlertDialogOverlay,
} from '@chakra-ui/react';
import React, { useState, useRef, useEffect } from 'react';
import { gql, useMutation } from '@apollo/client';
import UploadFile from '../UploadFile';
import { useTranslation } from 'react-i18next';

const UPDATE_PLAINTIFF_INVITATION_LETTER = gql`
	mutation add($attachmentFileSize: Float!, $attachmentFile: Upload!, $id: String!) {
		updateComplaintOnInsurancePlaintiffInvitationLetterFileById(attachmentFile: $attachmentFile, attachmentFileSize: $attachmentFileSize, id: $id)
	}
`;

const MUTATION_REMOVE_INVITATION_LETTER_FILE = gql`
	mutation rm($id: String!) {
		removeComplaintOnInsurancePlaintiffInvitationLetterFileById(id: $id)
	}
`;

export default function UploadPlaintiffInvitationLetter({ complaintId, callback, fileExist, disable }) {
	const { t, i18n } = useTranslation();
	const toast = useToast();

	const [sendFileData, { loading, error, data }] = useMutation(UPDATE_PLAINTIFF_INVITATION_LETTER);
	const [deleteFile, { loading: loadingRemoveFile, error: errorRemoveFile, data: dataRemoveFile }] = useMutation(MUTATION_REMOVE_INVITATION_LETTER_FILE);

	useEffect(() => {
		if (data?.updateComplaintOnInsurancePlaintiffInvitationLetterFileById) {
			toast({
				title: t('Invitation file uploaded successfully'),
				status: 'success',
				isClosable: true,
				position: 'top-right',
			});
			callback();
		}
	}, [data]);

	useEffect(() => {
		if (error) {
			error.graphQLErrors.map(({ message }, i) =>
				toast({
					title: t(message),
					status: 'error',
					isClosable: true,
					position: 'top-right',
				}),
			);
		}
	}, [error]);

	useEffect(() => {
		if (dataRemoveFile?.removeComplaintOnInsurancePlaintiffInvitationLetterFileById) {
			toast({
				title: t('Invitation file removed successfully'),
				status: 'success',
				isClosable: true,
				position: 'top-right',
			});
			callback();
		}
	}, [dataRemoveFile]);

	useEffect(() => {
		if (errorRemoveFile) {
			errorRemoveFile.graphQLErrors.map(({ message }, i) =>
				toast({
					title: t(message),
					status: 'error',
					isClosable: true,
					position: 'top-right',
				}),
			);
		}
	}, [errorRemoveFile]);

	return (
		<UploadFile
			fileContent={(data) => {
				sendFileData({
					variables: {
						attachmentFile: data.attachmentFile,
						attachmentFileSize: data.attachmentFileSize,
						id: complaintId,
					},
				});
			}}
			removeFile={() => {
				deleteFile({
					variables: { id: complaintId },
				});
			}}
			fileExist={fileExist}
			loading={loading}
			loadingRemoveFile={loadingRemoveFile}
			disable={disable}
		/>
	);
}
